import { Manager } from '@malesia/json-schema';
import { createActionsColumn } from '@malesia/react-components/dist/src/components/Table/columns/actionsColumn';
import * as layouts from './actions';

export const managerActionsColumn = createActionsColumn<Manager, typeof layouts>({
    columnsNumber: 2,
    rowsNumber: 1,
    layouts,
    order: [
        'editManager',
        'balanceLog',
    ],
});
export type ManagerActionsConfig = Parameters<typeof managerActionsColumn>[0];
